<template>
  <div>
    <TopMenu :leftOption="'back-dashboard'" :title="$t('Reports')"/>
    <div class="view">
      <transition name="fade" appear>
        <div class="p-4">
          <h5 class="text-white mb-3">{{$t('Export Play History')}}</h5>

          <form method="GET" action="/stats/report/" @submit="onSubmit">
            <input type="hidden" name="authToken" :value="authToken">

            <!-- Box Selection -->
            <div class="form-group">
              <label class="text-white">{{$t('Device')}}</label>
              <select
                ref="boxSelect"
                :disabled="boxes.length <= 1"
                name="box"
                class="form-control bg-dark border-0 text-white"
              >
                <option value="" v-if="boxes.length > 1">{{$t('All devices')}}</option>
                <option
                  v-for="box in boxes"
                  :value="box.uuid"
                  :key="box.uuid"
                >
                  {{ box.name || box.uuid }}
                </option>
              </select>
            </div>

            <!-- Date From -->
            <div class="form-group">
              <label class="text-white">{{$t('Date from')}}</label>
              <Datepicker
                v-model="dateFrom"
                name="date_from"
                format="dd-MM-yyyy"
                :monday-first="true"
                input-class="form-control bg-dark border-0 text-white"
              ></Datepicker>
            </div>

            <!-- Date To -->
            <div class="form-group">
              <label class="text-white">{{$t('Date to')}}</label>
              <Datepicker
                v-model="dateTo"
                name="date_to"
                format="dd-MM-yyyy"
                :monday-first="true"
                input-class="form-control bg-dark border-0 text-white"
              ></Datepicker>
            </div>

            <!-- Media Type -->
            <div class="form-group">
              <label class="text-white">{{$t('Content type')}}</label>
              <select name="media_type" class="form-control bg-dark border-0 text-white">
                <option value="">{{$t('All')}}</option>
                <option value="SONG">{{$t('Songs')}}</option>
                <option value="JINGLE">{{$t('Jingles')}}</option>
              </select>
            </div>

            <p class="text-muted small mt-4">
              {{$t('Reports data note')}}
            </p>

            <button type="submit" class="btn btn-primary btn-block mt-4">
              {{$t('Download CSV')}}
            </button>
          </form>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import localStorageUtil from '@/utils/localStorageUtil'

export default {
  name: 'Reports',

  data () {
    const today = new Date()
    const monthAgo = new Date(Date.now() - (30 * 24 * 60 * 60 * 1000))

    return {
      authToken: localStorageUtil.getToken(),
      dateFrom: monthAgo,
      dateTo: today
    }
  },

  computed: {
    boxes () {
      return this.$store.state.audio.allBoxes || []
    }
  },

  methods: {
    onSubmit (e) {
      // Enable the box select before form submission (in case it was disabled)
      // This ensures the value is included in the form data
      if (this.$refs.boxSelect) {
        this.$refs.boxSelect.disabled = false
      }
      // Allow form to submit naturally - browser handles the file download
      return true
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports.vue